var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "star-rating" },
    _vm._l(_vm.stars, function (star, index) {
      return _c("span", { key: index }, [
        _c(
          "svg",
          {
            staticClass: "star-rating-star",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              x: "0px",
              y: "0px",
              width: `${_vm.size}px`,
              height: `${_vm.size}px`,
              viewBox: "60 -62 309 309",
            },
          },
          [
            _c("polygon", {
              staticClass: "star-rating-star-wrap",
              attrs: {
                "data-side": "center",
                points:
                  "281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 212.9,181.1 213.9,181 306.5,241",
              },
            }),
            _vm._v(" "),
            _c("polygon", {
              staticClass: "star-rating-star-left",
              class: { filled: star.leftFilled },
              attrs: {
                "data-side": "left",
                points:
                  "281.1,129.8 364,55.7 255.5,46.8 214,-59 172.5,46.8 64,55.4 146.8,129.7 121.1,241 213.9,181.1 213.9,181 306.5,241",
              },
            }),
            _vm._v(" "),
            _c("polygon", {
              staticClass: "star-rating-star-right",
              class: { filled: star.rightFilled },
              attrs: {
                "data-side": "right",
                points:
                  "364,55.7 255.5,46.8 214,-59 213.9,181 306.5,241 281.1,129.8",
              },
            }),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }